<template>
  <section
    id="atividades"
    class="secao-direita-home"
  >
    <h5 class="card-header-title">Atividades disponíveis</h5>
    <div class="atividade-container">
      <div class="filtro-atividades">
        <FiltroSelect
          v-model="filtroAtividade"
          :items="unidades"
          :msg-todos="'Filtrar todas unidades'"
        />
      </div>

      <div
        v-if="isLoading"
        class="loading-container"
      >
        <Carregamento />
      </div>

      <template v-else-if="atividadesFiltradas.length > 0">
        <AtividadesCardHome
          v-for="atividade in atividadesFiltradas.slice(0, 8)"
          :key="atividade.id"
          :atividade="atividade"
        />
      </template>

      <p
        v-else
        class="sem-atividades"
      >
        Nenhuma atividade programada ou com inscrições abertas.
      </p>
    </div>

    <BaseButton to="/atividades"> Ver mais atividades </BaseButton>
  </section>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useAtividades } from "@/composables/useAtividades";
import { useUnidades } from "@/composables/useUnidades";
import AtividadesCardHome from "./AtividadesCardHome.vue";
import FiltroSelect from "@/components/common/FiltroSelect.vue";
import BaseButton from "@/components/common/BaseButton.vue";
import Carregamento from "@/components/common/Carregamento.vue";

const { atividades, isLoading, fetchAtividades, fetchAtividadesUnidade } =
  useAtividades();
const { unidades, fetchAllUnidades } = useUnidades();

const filtroAtividade = ref("");

function isAtividadeDisponivelHome(atividade) {
  if (!atividade) return false;
  return (
    atividade.status === "PROGRAMADA" ||
    atividade.status === "INSCRICOES_ABERTAS"
  );
}

const atividadesFiltradas = computed(() => {
  if (!Array.isArray(atividades.value)) return [];
  return atividades.value.filter(isAtividadeDisponivelHome);
});

async function carregarAtividades() {
  if (filtroAtividade.value) {
    await fetchAtividadesUnidade(0, 50, filtroAtividade.value);
  } else {
    await fetchAtividades(0, 50);
  }
}

watch(filtroAtividade, async () => {
  await carregarAtividades();
});

onMounted(async () => {
  await Promise.all([carregarAtividades(), fetchAllUnidades(0, 100)]);
});
</script>

<style scoped>
.secao-direita-home {
  width: 25%;
  min-width: 280px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#atividades {
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0;
  margin-left: auto;
}

.card-header-title {
  width: 100%;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  color: white;
  background-color: #5a35c8;
  border-radius: 0.4rem 0.4rem 0 0;
  margin: 0;
  box-sizing: border-box;
}

.filtro-atividades {
  width: 90%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.8rem 0.9rem 0.4rem 0.9rem;
}

.atividade-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  height: fit-content;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-top: none;
  border-radius: 0 0 0.4rem 0.4rem;
  padding: 0rem 0rem 0.5rem 0rem;
  box-sizing: border-box;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.loading-container {
  padding: 1.5rem 0;
}

.sem-atividades {
  font-size: 0.9rem;
  color: #666;
  text-align: center;
  padding: 1rem;
  margin: 0;
}

@media (max-width: 768px) {
  #atividades {
    width: 100%;
  }
}
</style>
